'use client';
import { useState, useRef } from 'react';
import { useTranslations as useTranslations$1 } from 'next-intl';
import { safePlay } from '@/lib/safePlay';
import { Play, Volume2, VolumeX } from '@/components/ui/icons';
interface MarketingVideoPlayerProps {
    src: string;
    autoPlay?: boolean;
    muted?: boolean;
    loop?: boolean;
    className?: string;
    ariaLabel?: string;
}
export function MarketingVideoPlayer({ src, autoPlay = false, muted = false, loop = false, className = '', ariaLabel }: MarketingVideoPlayerProps) {
    const t = useTranslations$1();
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(muted);
    const togglePlayPause = ()=>{
        const video = videoRef.current;
        if (!video) return;
        if (isPlaying) {
            video.pause();
            setIsPlaying(false);
        } else {
            safePlay(video);
            setIsPlaying(true);
        }
    };
    const toggleMute = ()=>{
        const video = videoRef.current;
        if (!video) return;
        video.muted = !isMuted;
        setIsMuted(!isMuted);
    };
    return (<div className={`relative overflow-hidden bg-black ${className}`}>
      { /* Video Element */ }
      <video ref={videoRef} src={src} autoPlay={autoPlay} muted={isMuted} loop={loop} playsInline preload="metadata" className="h-full w-full object-contain" aria-label={ariaLabel} onClick={togglePlayPause} onPlay={()=>setIsPlaying(true)} onPause={()=>setIsPlaying(false)}/>

      { /* Play Button - Only show when paused */ }
      {!isPlaying && (<button onClick={togglePlayPause} className="absolute inset-0 flex items-center justify-center bg-black/0 transition-colors hover:bg-black/10" aria-label={t("J3ca41")}>
          <div className="rounded-full bg-black/50 p-3 text-white">
            <Play className="h-6 w-6"/>
          </div>
        </button>)}

      { /* Mute Button - Always visible */ }
      <button onClick={(e)=>{
        e.stopPropagation();
        toggleMute();
    }} className="absolute bottom-4 end-4 rounded-full bg-black/50 p-2 text-white transition-colors hover:bg-black/70" aria-label={isMuted ? t("W9355R") : t("x82IOl")}>
        {isMuted ? <VolumeX className="h-5 w-5"/> : <Volume2 className="h-5 w-5"/>}
      </button>
    </div>);
}
